export default {
    // withCredentials: true,
    // withXSRFToken: true,
    // headers: {
    //     'Content-Type': 'application/json',
    //     Accept: 'application/json',
    // },
    baseURL: window.baseURL,
    timeout: 60000,
    paramsSerializer: (params) => {
        function serialize(obj, prefix) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    var k = prefix ? prefix + '[' + p + ']' : p;
                    var v = obj[p];
                    str.push(typeof v === 'object' ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
                }
            }
            return str.join('&');
        }

        return serialize(params);
    },
};
